import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./pages.css";

import products from "../data/products";

function HomePage({ setPage, blogs }) {
  const navigate = useNavigate();

  return (
    <Box>
      {/* HERO */}
      <Box className="hero">
        {/* LEFT SIDE */}
        <Box className="hero-left">
          <Typography className="hero-sub">
            SS25 COLLECTION — NOW LIVE
          </Typography>

          <Typography className="hero-title">
            NASTY <br /> AUTHENTIC
          </Typography>

          <Typography className="hero-desc">
            It's fast! It's trendy! It's affordable!
          </Typography>

          <Box className="hero-actions">
            <button
              className="primary-btn"
              onClick={() => navigate("/products")}
            >
              SHOP NOW
            </button>

            <button className="secondary-btn" onClick={() => navigate("/blog")}>
              READ BLOG
            </button>
          </Box>
        </Box>

        {/* RIGHT SIDE IMAGE */}
        <Box className="hero-right">
          <video
            autoPlay
            muted
            loop
            playsInline
            preload="none"
            style={{
              width: "100%",
              height: "520px",
              objectFit: "cover",
            }}
            aria-label="Promotional demo showing product."
          >
            <source
              src="https://res.cloudinary.com/dqj2x8qjx/video/upload/q_auto/f_auto/v1777654803/WhatsApp_Video_2026-05-01_at_14.41.58_a3lzw8.mp4"
              type="video/mp4"
            />
          </video>
        </Box>
      </Box>

      {/* CATEGORIES */}
      <Box className="page">
        <Typography className="section-title">SHOP BY CATEGORY</Typography>
        <Typography className="big-title">CATEGORIES</Typography>

        <Box className="cat-grid">
          {Object.entries(products).map(([key, category]) => (
            <Box
              key={key}
              className="cat-item"
              onClick={() => setPage("products")}
            >
              <Typography className="cat-label">{category.label}</Typography>
              <Typography className="cat-count">
                {category.items.length} ITEMS
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* BLOG */}
      <Box className="page">
        <Typography className="section-title">LATEST FROM THE BRAND</Typography>

        <Typography className="big-title">JOURNAL</Typography>

        <Box className="blog-grid">
          {blogs.slice(0, 3).map((b) => (
            <Box
              key={b.id}
              className="blog-card"
              onClick={() =>
                navigate(`/blog/${b.slug}`, { state: { blog: b } })
              }
            >
              <img src={b.image} alt="" className="blog-img" />

              <Box className="blog-body">
                <Typography className="blog-date">{b.date}</Typography>
                <Typography className="blog-title">{b.title}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default HomePage;
